import React from "react";
import { Modal, Button } from "antd";

class Delete extends React.Component {
  handleOk = () => {
    this.props.confirmDelete();
  };

  handleCancel = () => {
    this.props.closeDeletePopup();
  };

  render() {
    return (
      <Modal
        title=""
        visible={Boolean(this.props.visible)}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        className="deleteConfirmModal"
        footer={null}
        bodyStyle={{
          padding: "32px",
        }}
        width={440}
        destroyOnClose
        maskClosable={!this.props.deleteButtonLoading}
        closable={!this.props.deleteButtonLoading}
      >
        <p
          className="f-size-24px"
          style={{ fontWeight: 500, color: "#262626" }}
        >
          Delete Confirmation
        </p>
        <p className="pa-top-6px f-size-16px">
          {this.props.message
            ? this.props.message
            : "Are you sure you want to delete this record?"}
        </p>
        <div className="display-flex gap-12px pa-top-26px">
          <Button
            key="delete"
            type="primary"
            onClick={this.handleOk}
            loading={Boolean(this.props.deleteButtonLoading)}
            disabled={Boolean(this.props.deleteButtonLoading)}
          >
            Delete
          </Button>
          <Button
            key="cancel"
            onClick={this.handleCancel}
            disabled={Boolean(this.props.deleteButtonLoading)}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    );
  }
}

export default Delete;
